export const OAuthSettings: { [key: string]: string } = {
  development:
    '899641353964-4os4q32olqrjou5u4s2n8dos7dcs9gl6.apps.googleusercontent.com',
  staging:
    '899641353964-1d016scv00lggtf3j951j4almfptq7sq.apps.googleusercontent.com',
  production:
    '899641353964-esagv3tl4pr60dhvdq6f47jdoh4akf2t.apps.googleusercontent.com',
};
